export interface FeatureAccess {
	merchantIds?: string[];
	roles?: string[];
}

export const accessControlConfig: Record<string, FeatureAccess> = {
	pdfTicketPrint: {
		merchantIds: ['bio, mkv'],
		roles: ['SUPPORT'],
	},
	salePdfTicketPrint: {
		merchantIds: ['bio'],
		roles: ['SUPPORT'],
	},
};



// WEBPACK FOOTER //
// ./config/access-control.config.ts